<div class="btn-filter">
    <div class="search-controls">
        <action-button
            class="btn-search"
            (actionEvent)="search($event)"
            label="{{ 'headerFilters.searchButton' | translate }}"
            labelPosition="after"
            [ngClass]="'btn-search'"
            >
        </action-button>
        <filter-buttons
            (addFilter)="goToFilterPalette()"
            (clearFilters)="clearAllFilters()"
            >
        </filter-buttons>
    </div>
    <selected-filters
        [selectedFilters]="selectedFilters"
        (removeFilter)="removeFilter($event)"
        >
    </selected-filters>
</div>
